import CryptoJS from 'crypto-js';

/**
 * Encrypt posting key with PIN
 * @param {string} postingKey - The posting key to encrypt
 * @param {string} pin - 6-digit PIN code
 * @returns {string} Encrypted posting key
 */
export const encryptPostingKey = (postingKey, pin) => {
  if (!pin || pin.length !== 6 || !/^\d{6}$/.test(pin)) {
    throw new Error('PIN must be exactly 6 digits');
  }
  
  if (!postingKey || postingKey.trim() === '') {
    throw new Error('Posting key is required');
  }
  
  // Use PIN as encryption key (in production, you might want to derive a stronger key)
  const encrypted = CryptoJS.AES.encrypt(postingKey, pin).toString();
  return encrypted;
};

/**
 * Decrypt posting key with PIN
 * @param {string} encryptedKey - The encrypted posting key
 * @param {string} pin - 6-digit PIN code
 * @returns {string} Decrypted posting key
 */
export const decryptPostingKey = (encryptedKey, pin) => {
  if (!pin || pin.length !== 6 || !/^\d{6}$/.test(pin)) {
    throw new Error('PIN must be exactly 6 digits');
  }
  
  if (!encryptedKey || encryptedKey.trim() === '') {
    throw new Error('Encrypted key is required');
  }
  
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedKey, pin);
    const postingKey = decrypted.toString(CryptoJS.enc.Utf8);
    
    if (!postingKey) {
      throw new Error('Invalid PIN');
    }
    
    return postingKey;
  } catch (error) {
    throw new Error('Failed to decrypt posting key. Invalid PIN?');
  }
};

/**
 * Validate PIN format
 * @param {string} pin - PIN to validate
 * @returns {boolean} True if valid
 */
export const isValidPin = (pin) => {
  return pin && pin.length === 6 && /^\d{6}$/.test(pin);
};
